import { Link } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../../contexts/user.context"; 
// import { ReactComponent as LinearSVG } from "../../assets/vectors/linear.svg"; 

const AdminDashboard = () => {
  const { userRole } = useContext(UserContext); 
  console.log(userRole)

    document.title = "Admin Dashboard";


  return (
    <div className="min-h-screen bg-gray-50 p-1">
      <div className="max-w-5xl mx-auto">
        <header className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 tracking-tight">Admin Dashboard</h1>
          <p className="text-gray-500 mt-2">Overview of system activities and requests.</p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          
          {/* Property Approvals Card (Visible to all admins) */}
          <Link
            to="approvals"
            className="group block bg-white rounded-2xl p-6 shadow-[0_2px_8px_rgba(0,0,0,0.08)] border border-gray-100 hover:border-yellow-500 hover:shadow-md transition-all duration-300"
          >
            <div className="flex items-center justify-between mb-4">
              <div className="h-10 w-10 rounded-full bg-yellow-50 flex items-center justify-center group-hover:bg-yellow-500 transition-colors duration-300">
                {/* Check Shield Icon */}
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-600 group-hover:text-white transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 group-hover:text-yellow-600 transition-colors">
              Property Approvals
            </h3>
            <p className="text-sm text-gray-500 mt-1">
              Review and approve pending video tours.
            </p>
          </Link>

          {/* Withdrawal Card (Visible to all admins) */}
          <Link
            to="payouts"
            className="group block bg-white rounded-2xl p-6 shadow-[0_2px_8px_rgba(0,0,0,0.08)] border border-gray-100 hover:border-blue-600 hover:shadow-md transition-all duration-300"
          >
            <div className="flex items-center justify-between mb-4">
              <div className="h-10 w-10 rounded-full bg-blue-50 flex items-center justify-center group-hover:bg-blue-600 transition-colors duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 group-hover:text-white transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
              Payouts
            </h3>
            <p className="text-sm text-gray-500 mt-1">
              Manage pending payouts and transaction history.
            </p>
          </Link>

          {/* Admin Settings Card (Visible ONLY to super_admin) */}
          {userRole === "super_admin" && (
            <Link
              to="settings"
              className="group block bg-white rounded-2xl p-6 shadow-[0_2px_8px_rgba(0,0,0,0.08)] border border-gray-100 hover:border-purple-600 hover:shadow-md transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="h-10 w-10 rounded-full bg-purple-50 flex items-center justify-center group-hover:bg-purple-600 transition-colors duration-300">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-600 group-hover:text-white transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 group-hover:text-purple-600 transition-colors">
                Manage Staff
              </h3>
              <p className="text-sm text-gray-500 mt-1">
                Grant or revoke admin access and roles.
              </p>
            </Link>
          )}

        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;